module.exports = __webpack_public_path__ + "media/images/down_arrow-b218891e2923f708795abca848826ef1.png";